"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ContentFrameData2 = _interopRequireDefault(require("./ContentFrameData"));

var _deepEqual = _interopRequireDefault(require("../../utils/object/deepEqual"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _canvas = require("../../text/canvas");

var _TextRenderProperties = _interopRequireDefault(require("../text/TextRenderProperties"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextFrameData = /*#__PURE__*/function (_ContentFrameData) {
  (0, _inherits2["default"])(TextFrameData, _ContentFrameData);

  var _super = _createSuper(TextFrameData);

  function TextFrameData(textProperties, canvasFactory) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextFrameData);
    _this = _super.call(this, 0, 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canvas", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textLines", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textRenderProperties", null);
    _this._canvas = canvasFactory.getCanvas();
    var shouldMeasureText = (0, _isEmpty["default"])(textProperties.textLines) || (0, _isNil["default"])(textProperties.naturalHeight) || textProperties.naturalHeight === 0 || (0, _isNil["default"])(textProperties.naturalWidth) || textProperties.naturalWidth === 0;
    var textWidth;
    var textHeight;
    var textLines;
    var textRenderProperties;

    if (shouldMeasureText) {
      _this._textMeasurer = new _canvas.CanvasTextMeasurer(canvasFactory);
      textRenderProperties = _this._textMeasurer.getTextRenderProperties(textProperties);
      var _textRenderProperties = textRenderProperties,
          measuredHeight = _textRenderProperties.textHeight,
          measuredLines = _textRenderProperties.textLines,
          measuredWidth = _textRenderProperties.textWidth;
      textHeight = measuredHeight;
      textWidth = measuredWidth;
      textLines = measuredLines;
    } else {
      textHeight = textProperties.naturalHeight;
      textWidth = textProperties.naturalWidth;
      textLines = textProperties.textLines;
      textRenderProperties = new _TextRenderProperties["default"](textProperties, textLines, textWidth, textHeight);
    }

    _this._contentWidth = textWidth;
    _this._contentHeight = textHeight;
    _this._textLines = textLines;
    _this._textRenderProperties = textRenderProperties;
    return _this;
  }

  (0, _createClass2["default"])(TextFrameData, [{
    key: "equals",
    value: function equals(textFrameData) {
      if (!TextFrameData.isTextFrameData(textFrameData)) return false;
      if (this === textFrameData) return true; // TODO put equal on textProperties classes

      return (0, _deepEqual["default"])(textFrameData.textRenderProperties, this.textRenderProperties);
    }
  }, {
    key: "textLines",
    get: function get() {
      return this._textLines;
    }
  }, {
    key: "textRenderProperties",
    get: function get() {
      return this._textRenderProperties;
    }
  }], [{
    key: "isTextFrameData",
    value: function isTextFrameData(textFrameData) {
      return textFrameData instanceof TextFrameData;
    }
  }]);
  return TextFrameData;
}(_ContentFrameData2["default"]);

exports["default"] = TextFrameData;